import { Building2, PenLine, Tag, Wand2 } from "lucide-react"

import type { FrontendTriggerDefinition } from "../../types"

export const businessTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__business_created",
    label: "Business created",
    description: "Triggers when a new business is created",
    icon: Building2,
    providesSubjects: ["business"],
  },
  {
    key: "trigger__business_updated",
    label: "Attribute changed",
    description: "Triggers when a business name, industry, or website changes",
    icon: PenLine,
    providesSubjects: ["business"],
    inputFields: [
      {
        key: "watched_attributes",
        label: "When any of these change...",
        inputType: "multi_select",
        required: true,
        options: [
          { value: "name", label: "Name" },
          { value: "industry", label: "Industry" },
          { value: "website_url", label: "Website" },
        ],
      },
    ],
  },
  {
    key: "trigger__business_tag_added",
    label: "Tag added",
    description: "Triggers when a tag is added to a business",
    icon: Tag,
    providesSubjects: ["business"],
    inputFields: [
      {
        key: "tag_ids",
        label: "When the new tag is...",
        inputType: "multi_select",
        required: true,
        options: "dynamic_business_tags",
      },
    ],
  },
  {
    key: "trigger__business_magic_button",
    label: "Magic button",
    description: "Triggers when a magic button is pressed for a business",
    icon: Wand2,
    providesSubjects: ["business"],
    inputFields: [
      {
        key: "title",
        label: "Button title",
        inputType: "text",
        required: true,
        placeholder: "e.g., Start onboarding",
      },
      {
        key: "description",
        label: "Description",
        inputType: "textarea",
        required: true,
        placeholder: "What does this button do?",
      },
      {
        key: "icon_color",
        label: "Icon & color",
        inputType: "icon_color_picker",
        required: true,
        chatDefaultValue: { icon: "wand", color: "#0EA5E9" },
        iconOptions: [
          "wand",
          "sparkles",
          "zap",
          "brain",
          "bot",
          "dollar",
          "coins",
          "banknote",
          "piggy-bank",
          "landmark",
          "chart-line",
          "chart-pie",
          "briefcase",
          "phone",
          "mail",
          "send",
          "calendar",
          "clock",
          "bell",
          "document",
          "household",
          "handshake",
          "star",
          "check",
        ],
        colorFormat: "hex",
      },
    ],
  },
]
